import Axios from "axios";

export default function setDefaultAxiosUrl() {
  Axios.defaults.baseURL =
    process.env.NODE_ENV === "development"
      ? "https://api.assetbeyond.com"
      : "https://api.assetbeyond.com";
}
